import { render, staticRenderFns } from "./IconPrint.vue?vue&type=template&id=06a35c08&"
import script from "./IconPrint.vue?vue&type=script&lang=js&"
export * from "./IconPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports